import xiaomi from '../images/xiaomi_ax3200.png';
import hb210Pro from '../images/tp_link_hb210_pro.jpg';

/**
 * The picture for a router, by which router it is.
 *
 * The Wi-Fi 7 router we supply is the TP Link HB210 pro, and the catalogue
 * holds it twice: `wi-fi-7-router` (one off) and `WIFI-7-ROUTER-PAYG`
 * (twelve months). The ids are punctuated differently and neither spelling
 * is load bearing, so they are compared with the punctuation and the case
 * taken out. Everything else is the Wi-Fi 6 unit.
 */
const squeeze = (id: string): string => id.toLowerCase().replace(/[^a-z0-9]/g, '');

export const routerImageFor = (router: { id?: string }): string => (
  squeeze(router.id ?? '').includes('wifi7') ? hb210Pro : xiaomi
);

export default routerImageFor;
